import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import { Outlet } from "react-router";
import { Alert403 } from "@/shared/components/alerts/alert-403";
import { BaseDataPage } from "../_components/layout/base-data-page";

export function TextblocksBaseDataRoute() {
  const canAccess = useFeatureAuth("gsm.textblocks.catalog");
  if (!canAccess) {
    return (
      <BaseDataPage>
        <Alert403 />
      </BaseDataPage>
    );
  }

  return <Outlet />;
}
